(function (app) {

    app.provider("ancillaryEventGroupApi",
        [
            function() {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};

                        service.get = function(ancillaryEventGroupId) {
                            return marketingTrackerApiGateway.get("/AncillaryEventGroups/" + ancillaryEventGroupId);
                        };

                        service.getAncillaryEventGroups = function() {
                            return marketingTrackerApiGateway.getArray("/AncillaryEventGroups");
                        };

                        service.getUserAncillaryEventGroups = function(userId) {
                            return marketingTrackerApiGateway.getArray("/Users/" + userId + "/AncillaryEventGroups");
                        };

                        service.getAncillaryEvents = function(ancillaryEventGroupId) {
                            return marketingTrackerApiGateway.getArray("/AncillaryEventGroups/" + ancillaryEventGroupId + "/AncillaryEvents");
                        };

                        service.getAncillaryEvent = function(ancillaryEventGroupId, ancillaryEventId) {
                            return marketingTrackerApiGateway.get("/AncillaryEventGroups/" + ancillaryEventGroupId + "/AncillaryEvents/" + ancillaryEventId);
                        }

                        service.update = function(ancillaryEventGroupId, ancillaryEventGroup) {
                            return marketingTrackerApiGateway.put("/AncillaryEventGroups/" + ancillaryEventGroupId, ancillaryEventGroup);
                        };

                        service.updateAncillaryEvent = function(ancillaryEventGroupId, ancillaryEventId, ancillaryEvent) {
                            return marketingTrackerApiGateway.put("/AncillaryEventGroups/" + ancillaryEventGroupId + "/AncillaryEvents/" + ancillaryEventId, ancillaryEvent);
                        };

                        service.create = function(ancillaryEventGroup) {
                            return marketingTrackerApiGateway.post("/AncillaryEventGroups", ancillaryEventGroup);
                        };

                        service.addAncillaryEvent = function(ancillaryEventGroupId, ancillaryEvent) {
                            return marketingTrackerApiGateway.post("/AncillaryEventGroups/" + ancillaryEventGroupId + "/AncillaryEvents/", ancillaryEvent);
                        };

                        service.delete = function(ancillaryEventGroupId) {
                            return marketingTrackerApiGateway.delete("/AncillaryEventGroups/" + ancillaryEventGroupId);
                        };

                        service.deleteAncillaryEvent = function(ancillaryEventGroupId, ancillaryEventId) {
                            return marketingTrackerApiGateway.delete("/AncillaryEventGroups/" + ancillaryEventGroupId + "/AncillaryEvents/" + ancillaryEventId);
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line